import { civConfig, UnifiedItem } from "../../src/types/data";

export type SummaryResponse = {
  gameId: number;
  winReason: string;
  mapId: number;
  mapName: string;
  mapSize: string;
  mapSizeMaxPlayers: number;
  mapBiome: string;
  mapSeed: string;
  leaderboard: string;
  duration: number;
  startedAt: number;
  finishedAt: number;
  spectatorsCount: number;

  players: ReplayData[];

  error?: string;
};

export type ReplayData = {
  civilization: string;
  name: string;
  team: number;
  teamName: string;
  profileId: number;
  result: "win" | "loss";

  buildOrder: GroupedBuildSteps[];
  actions: Record<string, number[]>;
  resources: {
    timestamps: number[];
    food: number[];
    gold: number[];
    stone: number[];
    wood: number[];
    total: number[];
    society: number[];
    military: number[];
    economy: number[];
    technology: number[];

  };
  scores: {
    total: number;
    military: number;
    economy: number;
    technology: number;
    society: number;
  };
  totalResourcesSpent: {
    food: number;
    gold: number;
    stone: number;
    wood: number;
    oliveoil: number;
    total: number;
  }
  totalResourcesGathered: {
    food: number;
    gold: number;
    stone: number;
    wood: number;
    oliveoil: number;
    total: number;
  }
  apm: number;
  /** @deprecated Don't use in production */
  _stats: Record<string, number>;
};

type GroupedBuildSteps = {
  id: string;
  icon: string;
  pbgid?: number;
  type: string;
  finished: number[];
  constructed: number[];
  packed: number[];
  unpacked: number[];
  transformed: number[];
  destroyed: number[];
  fooMap: object;
  unknown: Record<string, number[]>
};

export type GameSummary = {
  name: string;
  civ: civConfig;
  team: number;
  teamName: string;
  profileId: number;
  position: number;
  color: string;
  resources: ReplayData["resources"];
  items: { item: UnifiedItem; counts: { build: number; lost: number }; build: number[]; lost: number[] }[];
  steps: { item: UnifiedItem; timestamp: number }[];
  groupedSteps: { item: UnifiedItem; count: number; timestamp: number; timestamps: number[] }[];
  scores: Partial<GameScores>;
  /** @internal tracking of issues found while parsing for reporting */
  issues?: string[];
};

export type GameScores = {
  total: number;
  military: number;
  economy: number;
  technology: number;
  society: number;

  totalResourcesGathered: number;
  totalWoodGathered: number;
  totalFoodGathered: number;
  totalGoldGathered: number;
  totalStoneGathered: number;
  totalOliveOilGathered: number;

  totalResourcesSpent: number;
  totalWoodSpent: number;
  totalFoodSpent: number;
  totalGoldSpent: number;
  totalStoneSpent: number;
  totalOliveOilSpent: number;

  sacredSitesCaptured: number;
  sacredSitesLost: number;
  sacredSitesNeutralized: number;

  workersMax: number;
  workersIdleTime: number;
  tradersMax: number;
  fishingMax: number;

  militaryProduced: number;

  militaryBuilt: number;
  kills: number;
  deaths: number;
  killsPerDeath: number;

  buildingsRazed: number;
  buildingsLost: number;

  researchProduced: number;

  apm: number;
};

export type ResourceType = "food" | "wood" | "gold" | "stone" | "oliveoil";
export const resourceTypeLiterals: ResourceType[] = ["food", "wood", "gold", "stone", "oliveoil"];
